// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/infoHeader.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
}
.infoMain .infoContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 97%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .infoMain .infoContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .infoMain .infoContainer {
    height: 100%;
  }
}
.infoMain .infoContainer .logo {
  width: 120px;
  height: 120px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  margin-top: 40px;
  background-repeat: no-repeat;
  text-align: center;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .logo {
    width: 140px;
    height: 140px;
    margin-top: 50px;
  }
}
.infoMain .infoContainer .logo .welcome {
  text-align: center;
  font-family: "Bitter", serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #FFFFFF;
  margin: 20px 0 0 0;
  padding: 0;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .logo .welcome {
    margin: 30px 0 0 0;
  }
}
.infoMain .infoContainer .logo .title {
  text-align: center;
  font-family: "Bitter", serif;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
  padding: 0;
  margin-left: -10px;
  color: #FFFFFF;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .logo .title {
    margin-left: -5px;
  }
}
.infoMain .infoContainer .optionsList {
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
}
.infoMain .infoContainer .optionsList .pointBlock, .infoMain .infoContainer .optionsList .pointBlockStrategy {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.infoMain .infoContainer .optionsList .pointBlock .pointNum, .infoMain .infoContainer .optionsList .pointBlockStrategy .pointNum {
  width: 30px;
  height: 30px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: #216B93;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}
.infoMain .infoContainer .optionsList .pointBlock .pointText, .infoMain .infoContainer .optionsList .pointBlockStrategy .pointText {
  margin-left: 16px;
  width: 100%;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 155%;
  color: #FFFFFF;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .optionsList .pointBlock .pointText, .infoMain .infoContainer .optionsList .pointBlockStrategy .pointText {
    font-size: 16px;
  }
}
.infoMain .infoContainer .optionsList .pointBlock .pointText p, .infoMain .infoContainer .optionsList .pointBlockStrategy .pointText p {
  margin: 0;
  padding: 0;
}
.infoMain .infoContainer .optionsList .pointBlockStrategy {
  align-items: flex-start;
}
.infoMain .infoContainer .optionsList .pointBlockStrategy .Relax, .infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced, .infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive {
  display: flex;
  width: 100%;
}
.infoMain .infoContainer .optionsList .pointBlockStrategy .Relax div:first-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced div:first-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive div:first-child {
  display: flex;
  padding: 3px 6px;
  align-items: center;
  background: #6D4ECB;
  border-radius: 100px;
  height: 100%;
  margin: 3px 0px;
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .optionsList .pointBlockStrategy .Relax div:first-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced div:first-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive div:first-child {
    font-size: 13px;
  }
}
.infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced div:first-child {
  background: #C465AE;
}
.infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive div:first-child {
  background: #FF6B6B;
}
.infoMain .infoContainer .optionsList .pointBlockStrategy .Relax div:last-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced div:last-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive div:last-child {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  color: #699BB6;
  margin-left: 10px;
}
@media only screen and (min-height: 712px) {
  .infoMain .infoContainer .optionsList .pointBlockStrategy .Relax div:last-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Balanced div:last-child, .infoMain .infoContainer .optionsList .pointBlockStrategy .Aggressive div:last-child {
    font-size: 13px;
  }
}
.infoMain .infoContainer .letsStartButton {
  margin-top: 20px;
  width: 320px;
  padding: 24px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  border: 0px solid;
}`, "",{"version":3,"sources":["webpack://./src/modules/info/index.scss","webpack://./src/scss/fonts.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AADJ;AAEI;EAII,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AANR;AANQ;EADJ;IAEQ,YAAA;EASV;AACF;AAPQ;EALJ;IAMQ,YAAA;EAUV;AACF;AAHO;EACK,YAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,gBAAA;EASA,4BAAA;EACA,kBAAA;AAHZ;AALY;EAPL;IAQS,YAAA;IACA,aAAA;IACA,gBAAA;EAQd;AACF;AAHY;EACI,kBAAA;EACA,4BC1CP;ED2CO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cEhDH;EFiDG,kBAAA;EAKA,UAAA;AAChB;AALgB;EATJ;IAUQ,kBAAA;EAQlB;AACF;AAJY;EACI,kBAAA;EACA,4BCzDP;ED0DO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EAKA,cEtEH;AFwEb;AANgB;EAVJ;IAWQ,iBAAA;EASlB;AACF;AAHQ;EACI,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAKZ;AAHY;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAKhB;AAJgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBEvFA;EFwFA,cEjGP;EFkGO,iCC7FX;ED8FW,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAMpB;AAJgB;EACI,iBAAA;EACA,WAAA;EACA,iCCtGX;EDuGW,eAAA;EAIA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cEnHP;AFsHb;AAToB;EALJ;IAMQ,eAAA;EAYtB;AACF;AAPoB;EACI,SAAA;EACA,UAAA;AASxB;AAJY;EACI,uBAAA;AAMhB;AALgB;EACI,aAAA;EACA,WAAA;AAOpB;AAJgB;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBE3HA;EF4HA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAMpB;AALoB;EAbJ;IAcQ,eAAA;EAQtB;AACF;AALoB;EACI,mBEzIJ;AFgJpB;AAJoB;EACI,mBErJJ;AF2JpB;AAHoB;EACI,mBAAA;EAEA,eAAA;EAIA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cErKP;EFsKO,iBAAA;AACxB;AARwB;EAJJ;IAKQ,eAAA;EAW1B;AACF;AADQ;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,cElLC;EFmLD,iCC9KH;ED+KG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAGZ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.infoMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    position: fixed;\n    .infoContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 97%;\n        height: 100dvh;\n        padding: 10px;\n       .logo{\n            width: 120px;\n            height: 120px;\n            background-image: url('../../assets//img/infoHeader.svg');\n            background-position: center;\n            margin-top: 40px;\n\n            @media only screen and (min-height: 712px) {\n                width: 140px;\n                height: 140px;\n                margin-top: 50px;\n\n            }\n\n            background-repeat: no-repeat;\n            text-align: center;\n            .welcome{\n                text-align: center;\n                font-family: $Bitter;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                color: $color-White;\n                margin: 20px 0 0 0 ;\n                @media only screen and (min-height: 712px) {\n                    margin:30px 0 0 0 ;\n\n                }\n                padding:0;\n            }\n            .title{\n                text-align: center;\n                font-family: $Bitter;\n                font-size: 50px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                margin:0;\n                padding:0;\n                margin-left: -10px;\n                @media only screen and (min-height: 712px) {\n                    margin-left: -5px;\n\n                }\n                color: $color-White;\n\n            }\n        }\n        .optionsList{\n            margin: 0 auto;\n            margin-top: 30px;\n            display: flex;\n            flex-direction: column;\n            margin-left: 10px;\n            margin-right: 10px;\n\n            .pointBlock , .pointBlockStrategy{\n                display: flex;\n                align-items: center;\n                margin-top: 15px;\n                .pointNum{\n                    width: 30px;\n                    height: 30px;\n                    padding: 10px;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 10px;\n                    border-radius: 20px;\n                    background: $color-Gradient-1-1;\n                    color: $color-White;\n                    font-family: $Roboto;\n                    font-size: 16px;\n                    font-style: normal;\n                    font-weight: 500;\n                    line-height: 140%; \n                }\n                .pointText{\n                    margin-left: 16px;\n                    width: 100%;\n                    font-family: $Roboto;\n                    font-size: 14px;\n                    @media only screen and (min-height: 712px) {\n                        font-size: 16px;\n                    }\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 155%; \n                    color: $color-White;\n                    p{\n                        margin: 0;\n                        padding: 0;\n                    }\n\n                }\n            }\n            .pointBlockStrategy{\n                align-items: flex-start;\n                .Relax, .Balanced, .Aggressive{\n                    display: flex;\n                    width: 100%;\n                    \n                }\n                .Relax div:first-child , .Balanced div:first-child,.Aggressive div:first-child{\n                    display: flex;\n                    padding: 3px 6px;\n                    align-items: center;\n                    background: $color-Gradient-3-1;\n                    border-radius: 100px;\n                    height: 100%;\n                    margin: 3px 0px;\n                    font-family: Arial;\n                    font-size: 12px;\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 12px;\n                    @media only screen and (min-height: 712px) {\n                        font-size: 13px;\n                    }\n                    }\n                \n                    .Balanced div:first-child{\n                        background: $color-Gradient-4-1;\n                    }\n                    \n                    .Aggressive div:first-child{\n                        background: $color-Gradient-2-2;\n\n                    }\n                    .Relax div:last-child , .Balanced div:last-child,.Aggressive div:last-child{\n                        font-family: Roboto;\n\n                        font-size: 12px;\n                        @media only screen and (min-height: 712px) {\n                            font-size: 13px;\n                        }\n                        font-style: normal;\n                        font-weight: 400;\n                        line-height: 130%;\n                        color:$color-Secondary;\n                        margin-left: 10px;\n                    }\n                  \n            }\n        }\n        .letsStartButton {\n            margin-top: 20px;\n            width: 320px;\n            padding: 24px;\n            background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n            text-align: center;\n            color: $color-White;\n            font-family: $Roboto;\n            font-weight: 400;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 10px;\n            text-align: center;\n            font-size: 16px;\n            font-style: normal;\n            border:0px solid\n          }\n    }\n}","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
